import { render, staticRenderFns } from "./GalleryProjects.vue?vue&type=template&id=0afa1d35&scoped=true&"
import script from "./GalleryProjects.vue?vue&type=script&lang=js&"
export * from "./GalleryProjects.vue?vue&type=script&lang=js&"
import style0 from "./GalleryProjects.vue?vue&type=style&index=0&id=0afa1d35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afa1d35",
  null
  
)

export default component.exports